// prettier-ignore
const SHAPES = {
  DOT: ['X'],

  DOUBLE: ['XX'],

  TRIO: ['XXX'],

  QUAD: ['XXXX'],

  QUIN: ['XXXXX'],

  BOX: ['XX', 
        'XX'],

  AWKS: ['XXX',
         'XX '],

  CORNER: ['XX',
           'X '],

  PISTOL: ['XXX',
           'X  '],

  RIFLE: ['XXXX',
          'X   '],

  UZI: ['XXXX',
        ' X  '],

  JIG: [' XXX',
        'XX  '],

  CHUNGUS: ['XXX',
            'X X'],
  
  BEST: ['XXX',
         'X  ',
         'X  '],
  
  T_POSE: ['XXX',
           ' X ',
           ' X '],
  
  ZIG: [' XX',
        ' X ',
         'XX '],
  
  T: ['XXX',
      ' X '],
  
  S: [' XX',
      'XX '],
  
  PLUS: [' X ',
         'XXX',
         ' X '],
  
  RAINBOW: [' XX',
            'XX ',
            'X  '],
  
  FIRST: [' XX',
          'XX ',
          ' X '],
};

export default SHAPES;
